export default __webpack_public_path__ + "static/media/goshen50.c790aaba.JPG";